export const getTitle = (pageTitle: string): string => {
  return `AI Sales Coach - ${pageTitle}`
}
